import "../css/Gallery.css";

const images = [
  "https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg",
  "https://images.pexels.com/photos/1833306/pexels-photo-1833306.jpeg",
  "https://images.pexels.com/photos/2074130/pexels-photo-2074130.jpeg",
  "https://images.pexels.com/photos/373639/pexels-photo-373639.jpeg",
  "https://images.pexels.com/photos/3184192/pexels-photo-3184192.jpeg",
  "https://images.pexels.com/photos/2067396/pexels-photo-2067396.jpeg",
];

const Gallery = () => {
  return (
    <main className="night-gallery">

      {/* INTRO */}
      <section className="gallery-intro">
        <h1>Gallery</h1>
        <p>
          Quiet moments.<br />
          Captured after dark.
        </p>
      </section>

      {/* EDITORIAL GRID */}
      <section className="gallery-grid">
        {images.map((img, index) => (
          <div
            key={index}
            className={`gallery-item ${index % 3 === 0 ? "wide" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </section>

      {/* CLOSING */}
      <section className="gallery-closing">
        <p>
          Some places don’t need words.<br />
          Just light, shadow, and time.
        </p>
      </section>

    </main>
  );
};

export default Gallery;
